<template>
  <section class="modeling-section" aria-labelledby="modeling-heading">
    <header class="head">
      <h2 id="modeling-heading" class="subtitle">Diseñamos tu pieza y la imprimimos</h2>
      <p class="text">
        Descríbenos qué necesitas y adjunta una imagen de referencia o un PDF
        con las especificaciones. Nosotros modelamos la pieza desde cero
        <strong>y</strong> la fabricamos.
      </p>
    </header>

    <div class="layout">
      <div class="left">
        <FileUploader
          :accepted-extensions="['png', 'jpg', 'jpeg', 'webp', 'pdf']"
          :accepted-mime-types="[
            'image/png',
            'image/jpeg',
            'image/webp',
            'application/pdf',
          ]"
          :max-size-mb="10"
          aria-label="Subir imagen o PDF de referencia"
          helper-text="Arrastra una imagen o PDF de referencia"
          @file-selected="onFileSelected"
          @file-cleared="onFileCleared"
        />

        <div v-if="attachment" class="preview">
          <img v-if="isImage" :src="previewUrl" :alt="`Vista previa de ${attachment.name}`" />
          <div v-else class="pdf-preview">
            <span class="pdf-icon" aria-hidden="true">📄</span>
            <div>
              <strong>{{ attachment.name }}</strong>
              <small>{{ humanSize }}</small>
            </div>
          </div>
        </div>
      </div>

      <div class="right">
        <ModelingRequestForm
          :has-attachment="!!attachment"
          :attachment="attachment"
        />
      </div>
    </div>
  </section>
</template>

<script>
import FileUploader from './FileUploader.vue';
import ModelingRequestForm from './ModelingRequestForm.vue';

export default {
  name: 'ModelingRequestSection',
  components: { FileUploader, ModelingRequestForm },
  data() {
    return {
      attachment: null,
      previewUrl: '',
    };
  },
  computed: {
    isImage() {
      return this.attachment && this.attachment.type.startsWith('image/');
    },
    humanSize() {
      if (!this.attachment) return '';
      const mb = this.attachment.size / (1024 * 1024);
      if (mb < 1) return `${(this.attachment.size / 1024).toFixed(1)} KB`;
      return `${mb.toFixed(2)} MB`;
    },
  },
  beforeUnmount() {
    this.revokePreview();
  },
  methods: {
    onFileSelected(file) {
      this.revokePreview();
      this.attachment = file;
      if (file.type.startsWith('image/')) {
        this.previewUrl = URL.createObjectURL(file);
      }
    },
    onFileCleared() {
      this.revokePreview();
      this.attachment = null;
    },
    revokePreview() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = '';
      }
    },
  },
};
</script>

<style scoped>
.modeling-section {
  width: 100%;
  background: #F1F5F9;
  border-radius: 16px;
  padding: 2rem;
  margin: 0 auto 4vw;
  box-sizing: border-box;
}

.head {
  margin-bottom: 1.5rem;
}

.head .subtitle {
  margin-bottom: 0.5rem;
}

.layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  align-items: start;
}

.left {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.preview {
  background: white;
  border: 1px solid #9DB2BF;
  border-radius: 8px;
  padding: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview img {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
}

.pdf-preview {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #2C3E50;
}

.pdf-icon {
  font-size: 2.4rem;
}

.pdf-preview strong {
  display: block;
  color: #2C3E50;
}

.pdf-preview small {
  color: #4F5665;
  font-size: 0.85rem;
}

@media (max-width: 800px) {
  .modeling-section {
    padding: 1.2rem;
  }
  .layout {
    grid-template-columns: 1fr;
  }
}
</style>
